import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { LibraryRef } from './types';

/** The library a page works on, from `?sensor_type=&category=`; null when either is missing. */
export function useLibraryRef(): LibraryRef | null {
  const [params] = useSearchParams();
  const sensorType = params.get('sensor_type') || '';
  const category = params.get('category') || '';
  return useMemo(() => (sensorType && category ? { sensor_type: sensorType, category } : null), [sensorType, category]);
}
